import { Effect, Matrix, Mesh, Nullable, Scene, ShaderMaterial, ShaderStore, SubMesh } from '@babylonjs/core';

import fragment from './shaders/sdfFont.fragment.fx';
import vertex from './shaders/sdfFont.vertex.fx';

const shaderName = 'sdfFont';
ShaderStore.ShadersStore[`${shaderName}FragmentShader`] = fragment;
ShaderStore.ShadersStore[`${shaderName}VertexShader`] = vertex;

export class SdfFontSimpleMaterial extends ShaderMaterial {
  constructor(name: string, scene: Scene) {
    super(name, scene, shaderName, {
      attributes: ['position', 'uv', 'charUv'],
      samplers: ['fontAtlas'],
      uniforms: ['world', 'viewProjection', 'texelSize', 'visibility', 'uColor'],
      uniformBuffers: ['Material', 'Mesh'],
      needAlphaBlending: true,
    });
  }

  override bind(world: Matrix, mesh?: Mesh, effectOverride?: Nullable<Effect>, subMesh?: SubMesh) {
    super.bind(world, mesh, effectOverride, subMesh);

    if (!this._activeEffect || !mesh) return;
    this._activeEffect.setFloat('visibility', mesh.visibility);
  }
}
